import React from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {Button, Modal, Paragraph, RoboyuOffer} from 'common/components'
import convertUnit from 'lib/unit'
import {useSelector} from 'lib/redux'

const StyledModal = styled(Modal)`
  width: ${convertUnit(300)};
  padding: ${convertUnit(20)};
  display: flex;
  flex-direction: column;
  text-align: center;
`
const StyledTitle = styled(Paragraph)`
  margin-bottom: ${convertUnit(12)};
`
const StyledButton = styled(Button)`
  margin-top: ${convertUnit(20)};
`
const StyledRoboyuContainer = styled.div`
  width: 100%;
  height: 100%;
  max-height: ${convertUnit(200)};
  max-width: ${convertUnit(200)};
  display: flex;
  justify-content: center;
  align-self: center;
`

interface ModalReprocessKycItemProps {
  onClickOk(): void
}

export default function ModalReprocessKycItem({
  onClickOk,
}: ModalReprocessKycItemProps) {
  const {translate} = useTranslation()
  const {colorTheme} = useSelector('roboyuState')

  return (
    <StyledModal visible onBackdropPress={onClickOk}>
      <StyledTitle fontWeight="bold" fontSize="xl">
        {translate('giftShop:roboyuActivationProcessingHeader')}
      </StyledTitle>
      <Paragraph fontSize="l">
        {translate('giftShop:similarWaitingApprovalSubtitle')}
      </Paragraph>
      <StyledRoboyuContainer>
        <RoboyuOffer
          width={convertUnit(200)}
          height={convertUnit(200)}
          colorTheme={colorTheme.name}
        />
      </StyledRoboyuContainer>
      <Paragraph fontSize="m" color="gray_5">
        {translate('giftShop:similarWaitingApprovalDesc')}
      </Paragraph>
      <StyledButton label={translate('global:ok')} onClick={onClickOk} />
    </StyledModal>
  )
}
